// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reactions-wrapper[data-v-07b8c668] {
  margin: 0 0.3em;
  transition: all 0.25s;
  border-radius: 1em;
  background-color: var(--reactions-items-bgcolor);
}
.reactions-wrapper.isThreadsRightSide[data-v-07b8c668] {
  margin-right: 1.34em;
}
.reactions-wrapper .reaction-items[data-v-07b8c668] {
  cursor: pointer;
  transition: all 0.25s;
  display: flex;
  align-items: center;
  border-radius: 0.5em;
  z-index: 999;
}
.reactions-wrapper .reaction-items .reaction-item-wrapper[data-v-07b8c668] {
  display: flex;
  padding: 2px;
}
.reactions-wrapper .reaction-items .reaction-item-wrapper .agg-reactions-show[data-v-07b8c668] {
  display: flex;
  align-items: center;
  padding-left: 0.1em;
  padding-right: 0.1em;
  margin-top: -1px;
}
.reactions-wrapper .reaction-items .reaction-item-wrapper .agg-reactions-show .reaction-item[data-v-07b8c668] {
  transition: all 0.25s;
  font-size: 1.25rem;
  filter: contrast(1.1);
  align-self: center;
  margin-bottom: -2px;
}
.reactions-wrapper .reaction-items .reaction-item-wrapper .agg-reactions-show .reaction-item-count[data-v-07b8c668] {
  font-size: 1.1rem;
  padding-left: 2px;
  padding-right: 2px;
  color: var(--message-grey-color);
  margin-bottom: -1px;
}
.reactions-wrapper .reaction-items[data-v-07b8c668]:hover {
  transition: all 0.25s;
}
.reactions-wrapper .reaction-items:hover .reaction-item[data-v-07b8c668] {
  transition: all 0.25s;
  width: auto;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/chat/reactions/Reactions.vue"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,gDAAgD;AAClD;AACA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,WAAW;AACb","sourcesContent":[".reactions-wrapper[data-v-07b8c668] {\n  margin: 0 0.3em;\n  transition: all 0.25s;\n  border-radius: 1em;\n  background-color: var(--reactions-items-bgcolor);\n}\n.reactions-wrapper.isThreadsRightSide[data-v-07b8c668] {\n  margin-right: 1.34em;\n}\n.reactions-wrapper .reaction-items[data-v-07b8c668] {\n  cursor: pointer;\n  transition: all 0.25s;\n  display: flex;\n  align-items: center;\n  border-radius: 0.5em;\n  z-index: 999;\n}\n.reactions-wrapper .reaction-items .reaction-item-wrapper[data-v-07b8c668] {\n  display: flex;\n  padding: 2px;\n}\n.reactions-wrapper .reaction-items .reaction-item-wrapper .agg-reactions-show[data-v-07b8c668] {\n  display: flex;\n  align-items: center;\n  padding-left: 0.1em;\n  padding-right: 0.1em;\n  margin-top: -1px;\n}\n.reactions-wrapper .reaction-items .reaction-item-wrapper .agg-reactions-show .reaction-item[data-v-07b8c668] {\n  transition: all 0.25s;\n  font-size: 1.25rem;\n  filter: contrast(1.1);\n  align-self: center;\n  margin-bottom: -2px;\n}\n.reactions-wrapper .reaction-items .reaction-item-wrapper .agg-reactions-show .reaction-item-count[data-v-07b8c668] {\n  font-size: 1.1rem;\n  padding-left: 2px;\n  padding-right: 2px;\n  color: var(--message-grey-color);\n  margin-bottom: -1px;\n}\n.reactions-wrapper .reaction-items[data-v-07b8c668]:hover {\n  transition: all 0.25s;\n}\n.reactions-wrapper .reaction-items:hover .reaction-item[data-v-07b8c668] {\n  transition: all 0.25s;\n  width: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
